module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-p-130x130q80-88d6554367f949f195e2a066ec38ca48.jpg";